<ng-container *transloco="let t">
  <authority-labs-check-case
    [inspection]="inspection"
    [fieldSection]="fieldSection"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onChange()"
  >
    <mat-form-field floatLabel="always" appearance="fill">
      <mat-label>{{
        t('inspection.fields.dialRisk:dialerPhoneNumber')
      }}</mat-label>
      <input
        type="text"
        matInput
        [drawableField]="(fieldSection || '') + ':dialNumber'"
        [drawableFieldTitle]="t('inspection.fields.dialRisk:dialerPhoneNumber')"
        [drawableFieldReadonly]="readonly"
        [(ngModel)]="inspection.dialNumber"
        [readonly]="readonly || printPreview"
        (input)="onChange()"
      />
    </mat-form-field>
    <div
      class="contact"
      *ngFor="let contact of inspection.contacts; let i = index"
    >
      <p class="sub-title">
        {{ t('inspection.fields.dialRisk:report') }} {{ i + 1 }}
      </p>
      <mat-form-field floatLabel="always" appearance="fill">
        <mat-label>{{
          t('inspection.fields.dialRisk:dialerTargetPhone')
        }}</mat-label>
        <input
          type="text"
          matInput
          [drawableField]="(fieldSection || '') + ':contact:' + i + ':phone'"
          [drawableFieldTitle]="
            t('inspection.fields.dialRisk:dialerTargetPhone')
          "
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="contact.phone"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="fill">
        <mat-label>{{
          t('inspection.fields.dialRisk:messageRecipientName')
        }}</mat-label>
        <input
          type="text"
          matInput
          [drawableField]="(fieldSection || '') + ':contact:' + i + ':name'"
          [drawableFieldTitle]="
            t('inspection.fields.dialRisk:messageRecipientName')
          "
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="contact.name"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
      </mat-form-field>
      <div class="actions" *ngIf="!(readonly || printPreview)">
        <button
          mat-raised-button
          aria-label="remove"
          (click)="removeContact(i)"
          *ngIf="inspection.contacts.length > 1"
        >
          <span>{{ t('inspection.fields.plans:remove') }}</span>
        </button>
        <button
          mat-raised-button
          aria-label="add"
          class="add"
          (click)="addContact()"
          *ngIf="i === inspection.contacts.length - 1"
        >
          <span>{{ t('add') }}</span>
        </button>
      </div>
    </div>
    <mat-form-field floatLabel="always" appearance="fill">
      <mat-label>{{
        t('inspection.fields.dialRisk:dialerCheckTime')
      }}</mat-label>
      <input
        type="text"
        matInput
        [drawableField]="(fieldSection || '') + ':checkTime'"
        [drawableFieldTitle]="t('inspection.fields.dialRisk:dialerCheckTime')"
        [drawableFieldReadonly]="readonly"
        [(ngModel)]="inspection.checkTime"
        [readonly]="readonly || printPreview"
        (input)="onChange()"
      />
    </mat-form-field>
  </authority-labs-check-case>
</ng-container>
